import { createEnum } from '../libs/utils';

/** @enum {number} */
export const AccountStatus = createEnum({
  Enabled: 0, // 启用
  Disabled: -1, // 禁用
});

/** @enum {number} */
export const AccountRole = createEnum({
  Admin: 1, // 管理员
  Operator: 2, // 运营
  Agency: 3, // 代理
  NormalUser: 4, // 普通用户
});

/** @enum {number} */
export const AccountSubRole = createEnum({
  SuperAdmin: 1, // 超级管理员
  Admin: 2, // 管理员
  Manager: 3, // 经纪人
});

/** @enum {number} */
export const AccountPermission = createEnum({
  ModifyAccount: 1, // 编辑主账号权限
  ResetPassword: 2, // 重置主账号密码权限
  ModifySubAccount: 3, // 编辑子账号权限（增删查改）
  BatchAuth: 4, // 批量授权
  ActionLog: 5, // 权限管理操作日志
  AgencyStat: 6, // 代理直播数据查看
  OperatorStat: 7, // 运营指标数据查看
  InterviewPermission: 12, // 面试模块权限
  DataPermission: 13, // 列表数据权限
  AgencyNotification: 14, // 代理通知

  // 对公结算权限
  PaymentDistributionUpload: 8,
  PaymentDistributionBackend: 9,
  PaymentBlacklist: 10,
  PaymentActionLog: 11,

  CoreMetrics: 15, // 代理汇总数据查看
  // AgencyPaymentMethod: 16, // 代理发薪方式管理(已废弃，现在是基础后台返回的101控制权限)
  AgencyPaymentMethod: 101, // 左侧"by beans method"
  paymentMethodEntrance: 102, // 右上角payment method入口
  PaymentMethod: 17, // 发薪方式管理
  PaymentMethodBankInfo: 18, // 发薪方式管理-银行信息查看
  AgencyBroadcasterRecruitment: 19, // 代理主播招募
  AgencyBroadcasterList: 20, // 代理主播列表
  AgencyGuildSecurity: 21, // 代理安全中心
  AgencyGuildTeam: 22, // 代理团队管理
  LiveDataAnalysis: 23, // 数据分析-67110
  BroadcasterLiveData: 24, // 代理主播列表-67110
  AssignPkList: 25, // 分配PK对手
  TransferRelation: 26, // 主播关系变更
  ActRegist: 27, // 主播活动报名
  NewBroadcasterData: 103, // 82451 新主播数据专区
  BigoTutorialEntry: 104, // 85157 Bigo教程入口
  AgencyGuildTask: 105, // 代理公会任务
  AgencyGuildPromoter: 106, // 推广员管理菜单
});

export const countryCodes = [
  'SA',
  'JO',
  'EG',
  'AE',
  'KW',
  'LB',
  'IQ',
  'PS',
  'YE',
  'OM',
  'SY',
  'QA',
  'BH',
  'SD',
  'LY',
  'TN',
  'DZ',
  'MA',
  'SO',
  'IR',
  'IL',
  'MR',
  'DJ',
  'KM',
  'CY',
  'TR',
  'IT',
  'DE',
  'AT',
  'CH',
  'NL',
  'SE',
  'NO',
  'FI',
  'DK',
  'FR',
  'BE',
  'PL',
  'RO',
  'ZA',
  'NG',
  'KE',
  'GH',
  'RU',
  'UA',
  'BY',
  'GE',
  'AM',
  'AZ',
  'TJ',
  'TM',
  'KG',
  'UZ',
  'KZ',
  'MD',
  'BR',
  'AO',
  'PT',
  'MX',
  'AR',
  'CO',
  'BO',
  'CL',
  'CR',
  'DO',
  'EC',
  'SV',
  'GT',
  'HN',
  'NI',
  'PA',
  'PY',
  'PE',
  'UY',
  'VE',
  'PR',
  'CU',
  'ES',
  'US',
  'GB',
  'CA',
  'IE',
  'AU',
  'NZ',
  'PG',
  'TO',
  'WS',
  'FJ',
  'GU',
  'SB',
  'NC',
  'PF',
  'PW',
  'AS',
  'FM',
  'TK',
  'MP',
  'CK',
  'VU',
  'MH',
  'KI',
  'NR',
  'TV',
  'NU',
  'NF',
  'WF',
  'PN',
  'IN',
  'BD',
  'NP',
  'PK',
  'ID',
  'PH',
  'VN',
  'TH',
  'LA',
  'KH',
  'MM',
  'MY',
  'BN',
  'SG',
  'JP',
  'KR',
  'CN',
  'TW',
  'HK',
  'MO',
  'AD',
  'AF',
  'AL',
  'BF',
  'BG',
  'BI',
  'BJ',
  'BM',
  'BT',
  'BW',
  'CD',
  'CF',
  'CG',
  'CI',
  'CM',
  'CV',
  'CW',
  'CX',
  'CZ',
  'EE',
  'ER',
  'ET',
  'GA',
  'GM',
  'GN',
  'GQ',
  'GR',
  'GW',
  'HU',
  'IS',
  'JM',
  'KP',
  'KY',
  'LI',
  'LK',
  'LR',
  'LS',
  'LT',
  'LU',
  'LV',
  'MC',
  'MG',
  'ML',
  'MN',
  'MQ',
  'MT',
  'MU',
  'MV',
  'MW',
  'MZ',
  'NA',
  'NE',
  'RE',
  'RS',
  'RW',
  'SC',
  'SS',
  'ST',
  'SZ',
  'TD',
  'TG',
  'TL',
  'TZ',
  'UG',
  'VC',
  'VG',
  'XK',
  'ZM',
  'ZW',
  'SK',
  'BA',
  'BL',
  'MK',
  'HR',
  'MF',
  'SI',
  'SM',
  'AX',
  'GP',
  'ME',
  'FO',
  'GI',
  'GL',
  'SU',
  'UN',
  'UR',
  'BQ',
  'SX',
  'JE',
  'IM',
  'GG',
  'VA',
  'AG',
  'AI',
  'BB',
  'BS',
  'BZ',
  'GD',
  'GF',
  'GY',
  'HT',
  'LC',
  'MS',
  'SR',
  'TT',
  'AW',
  'KN',
  'TC',
  'VI',
  'AN',
  'BU',
  'EL',
  'DM',
  'KT',
  'SL',
  'SN',
  'LW',
  'YT',
  'COM',
  'AC',
  'AP',
  'HA',
  'HO',
  'JA',
  'KA',
  'KO',
  'PO',
  'SP',
  'TP',
  'TU',
  'UK',
  'ZZ',
  'LE',
  'Other',
];
// 代理角色状态
export const KYC_AGENT_ROLE = {
  // 1-代理，2-子代理，3-经纪人，4-代理签约中，5-非代理/子代理/非经纪人但有资格申请，6-其他
  AGENT: 1,
  AGENTCHILD: 2,
  BROKER: 3,
  APPLYING: 4,
  CANAPPLY: 5,
  OTHER: 6,
};

export const KYC_SOURCE = {
  APP: 1,
  PC: 2,
};

export const PLAT_TYPE = {
  APP: 1,
  PC: 2,
};

export const EMAILFORM = {
  // 0 不显示 1 必填  2 非必填
  HIDDEN: 0,
  REQUIRED: 1,
  NOTREQUIRED: 2,
};

export const ROLE_SOURCE = {
  ME: 1,
  PC: 2,
  OTHER: 0,
};

/** @enum {number} */
export const AgentUserTypeReport = createEnum({
  NoProfile: 0, // 没有身份
  SuperAdmin: 1, // 超级管理员/超级管理员
  Operator: 2, // 区域运营
  AgencyAgent: 3, // 代理
  AgencySubAgent: 4, // 子代理
  AgencyManager: 5, // 经纪人
});
